import React, { PureComponent } from 'react';
import { PropInfo, CodeExample, CurrencySelectorProps } from '@cimpress/react-components';
import CurrencySelectorCode from '!raw-loader!./currencyselector.jsx';
import ComponentDoc from '../../shared/TabbedComponentDoc';
import CurrencySelectorDemo from './currencyselector';

const propInfos: PropInfo<CurrencySelectorProps>[] = [
  {
    name: 'currency',
    type: 'string | string[]',
    default: '',
    description: 'String or array of strings representing the currently selected currency code(s).',
  },
  {
    name: 'onChange',
    type: 'function',
    default: '',
    description: (
      <div>
        <p>Callback function that is fired when a user selects a currency. </p>
        <p>
          Signature:{' '}
          <code>
            function(&#123; value: string, label: string, flag: node, symbol: string, country: string, iso2: string
            &#125;) {'=>'} void
          </code>{' '}
        </p>
        <p>
          <code>value:</code> 3-letter code for the selected currency.
        </p>
        <p>
          <code>label:</code> The name of the currency's originating country or region.
          <br />
        </p>
        <p>
          <code>flag:</code> Image for the flag of the currency's originating country or region.
          <br />
        </p>
        <p>
          <code>symbol:</code> The symbol (ie $) representing the currency.
          <br />
        </p>
        <p>
          <code>country:</code> The name of the currency's originating country or region.
          <br />
        </p>
        <p>
          <code>iso2:</code> The 2-character iso code for the currency's originating country or region.
          <br />
        </p>
      </div>
    ),
  },
  {
    name: 'className',
    type: 'string',
    default: '',
    description: 'Additional className to apply to the selector.',
  },
  {
    name: 'isDisabled',
    type: 'boolean',
    default: 'false',
    description: 'Boolean determining whether to disable the selector.',
  },
  {
    name: 'disabledCurrencies',
    type: 'string[]',
    default: '[]',
    description: 'A list of ISO 4217 3-letter currency codes to disable.',
  },
  {
    name: 'isMulti',
    type: 'boolean',
    default: 'false',
    description: 'Boolean determining whether to allow multiple currency selections.',
  },
  {
    name: 'label',
    type: 'string',
    default: 'Currency',
    description: 'Floating label for the Select input element.',
  },
  {
    name: 'displayFullName',
    type: 'boolean',
    default: 'false',
    description: 'Boolean determining whether to display full currency names or 3-character currency codes.',
  },
  {
    name: 'isClearable',
    type: 'boolean',
    default: 'false',
    description: 'Boolean determining whether the Select element is clearable.',
  },
];

export default class CurrencySelectorDocs extends PureComponent {
  render() {
    return (
      <ComponentDoc<CurrencySelectorProps> name="Currency Selector" propInfos={propInfos}>
        <CurrencySelectorDemo />
        <CodeExample code={CurrencySelectorCode} />
      </ComponentDoc>
    );
  }
}
